module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isDropdown) ? _c('div', {
    ref: "copy_event_panel",
    staticClass: "copy-event text-dark"
  }, [_c('transition', {
    attrs: {
      "name": "fadeInDown"
    }
  }, [(_vm.isDropdownPopperDone) ? _c('div', {
    staticClass: "copy-event__panel"
  }, [_c('h3', {
    style: ({
      'backgroundColor': _vm.event.color
    })
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.copycalendar.copy')) + " " + _vm._s(_vm.event.title) + ", " + _vm._s(_vm.showDateAndTime) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle copy-event__panel__close-cross",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDropdown.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "copy-event__panel__container"
  }, [_c('div', {
    staticClass: "weeks-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.componentActiveSchoolYearId),
      expression: "componentActiveSchoolYearId"
    }],
    staticClass: "school-year-selector",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.componentActiveSchoolYearId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.activeSchoolYears), function(year) {
    return _c('option', {
      key: year.id,
      domProps: {
        "value": year.id
      }
    }, [_vm._v("\n              " + _vm._s(year.name) + "\n            ")])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "weeks"
  }, [(_vm.weeks.length < 1) ? [_c('Spinner', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "color": "blue"
    }
  })] : _vm._l((_vm.weeks), function(week) {
    return _c('li', {
      key: week.serverDate,
      staticClass: "weeks__week hint--top",
      class: [{
          'weeks__week--is-selected': _vm.isWeekSelected(week)
        },
        {
          'weeks__week--is-copy-week': _vm.isCopyWeek(week)
        }
      ],
      attrs: {
        "aria-label": _vm.tooltipDate(week.date)
      },
      on: {
        "click": function($event) {
          return _vm.setSelectedWeek(week)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("showWeek")(week.date)) + "\n                "), (_vm.isNow(week)) ? _c('span', {
      staticClass: "weeks__week__now-indicator"
    }) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "copy-event__panel__sidebar"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + "\n            " + _vm._s(_vm._f("showWeek")(_vm.copyDate)))]), _vm._v(" "), _c('button', {
    staticClass: "bttn width-100 btn-trans",
    on: {
      "click": _vm.addAllWeeksOnward
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn width-100 btn-trans",
    on: {
      "click": _vm.selectOddWeeks
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn width-100 btn-trans",
    on: {
      "click": _vm.selectEvenWeeks
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn btn-trans width-100 btn-remove",
    on: {
      "click": _vm.removeAllSelectedWeeks
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "copy-event__panel__footer"
  }, [(_vm.selectedWeeks.length < 1) ? _c('button', {
    staticClass: "bttn bttn--disabled"
  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')) + "\n        ")]) : _c('button', {
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')))])])]) : _vm._e()]), _vm._v(" "), (_vm.isDropdown) ? _c('div', {
    ref: "d_copy_event_overlay",
    staticClass: "copy-event__overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDropdown.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71497a34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/CopyEvent.vue
// module id = 1716
// module chunks = 1